/**
 * Returns the row of the given cell
 * */
export const getRowFromCell = (cell: HTMLTableCellElement | null) =>
  cell?.parentElement as HTMLTableRowElement | null;

/**
 * Returns the table body of the given row
 * */
export const getBodyFromRow = (tr: HTMLTableRowElement | null) =>
  tr?.parentElement as HTMLTableSectionElement | null;

/**
 * Returns the table body of the given row
 * */
export const getBodyFromTable = (table: HTMLTableElement | null) =>
  table?.tBodies[0] as HTMLTableSectionElement | null;

/**
 * Returns the rows of the given table body
 * */
export const getRowsFromBody = (tbody: HTMLTableSectionElement | null) =>
  Array.from(tbody?.rows || []) as HTMLTableRowElement[];

/**
 * Returns the table of the given table body
 * */
export const getTableFromBody = (tbody: HTMLTableSectionElement | null) =>
  tbody?.parentElement as HTMLTableElement | null;

/**
 * Returns the table of the given table body row
 * */
export const getTableFromBodyRow = (tr: HTMLTableRowElement | null) =>
  getTableFromBody(getBodyFromRow(tr));

/**
 * Returns the header of the given table
 * */
export const getHeaderFromTable = (table: HTMLTableElement | null) =>
  table?.tHead as HTMLTableSectionElement | null;

/**
 * Returns the cells of the given row
 * */
export const getCellsFromRow = (tr: HTMLTableRowElement | null) =>
  Array.from(tr?.children || []) as HTMLTableCellElement[];

/**
 * Returns the cells of the table header
 * */
export const getCellsFromHeader = (thead: HTMLTableSectionElement | null) =>
  Array.from(thead?.firstElementChild?.children || []) as HTMLTableCellElement[];

/**
 * Returns the header cell at the same index as the given body cell
 * */
export const getHeaderCellAtIndex = (cell: HTMLTableCellElement | null) => {
  if (!cell) {
    return;
  }
  const tr = getRowFromCell(cell);
  const table = getTableFromBodyRow(tr);
  const thead = getHeaderFromTable(table);
  const tds = getCellsFromRow(tr);
  const currentIndexInCells = tds.indexOf(cell);
  const ths = getCellsFromHeader(thead);
  return ths[currentIndexInCells];
};
